export const isOnsite = product => product.business === 'Media Onsite';
export const isOffsite = product => product.business === 'Media Offsite';
export const isCreative = product => product.business === 'Creative';

export const isOffline = product => product.productGroup === 'Offline';

export const isCCP = product => product.code.includes('CCP');

export const isCIDash = product => product.code === 'CI_DASH';
export const isCISetup = product => product.code === 'CI_SETUP';

export const isCountdown = product => product.code.includes('COUNTDOWN');

export const getRelatedCIProduct = (product, products) => {
  const companionProdCode = isCIDash(product) ? 'CI_SETUP' : 'CI_DASH';
  return products.find(prod => prod.code === companionProdCode);
};

export const getOperativeSystem = product => {
  return product.supportsAdManager ? 'zms_am' : product.operativeSystem;
};
